import type { VirtualAppointmentLoadStatus } from '@odo/shared-ui/clinical/virtualAppointments/types';
import { loadStatusGate, vaTriggerGate, type VaTriggerGate } from './vaTriggerGate';

const NOTHING_OPEN_REASON = 'No open VAs; continue treatment instead';

// Open VAs never block a team switch: the backend moves them along with the case.
function teamSwitchGate(
    status: VirtualAppointmentLoadStatus,
    open: readonly unknown[]
): VaTriggerGate {
    const loadGate = loadStatusGate(status);
    if (loadGate) return loadGate;
    if (open.length === 0) return { enabled: false, blockedReason: NOTHING_OPEN_REASON };
    return { enabled: true };
}

export function handBackToDmGate(
    status: VirtualAppointmentLoadStatus,
    open: readonly unknown[]
): VaTriggerGate {
    return teamSwitchGate(status, open);
}

export function escalateToClinicalGate(
    status: VirtualAppointmentLoadStatus,
    open: readonly unknown[]
): VaTriggerGate {
    return teamSwitchGate(status, open);
}

// Same rule as the refinement/retention triggers: no open VAs left.
export function continueTreatmentGate(
    status: VirtualAppointmentLoadStatus,
    openCount: number
): VaTriggerGate {
    return vaTriggerGate(status, openCount);
}
